import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/crm/customer-order/{id}/reopen`：CLOSED → 結案前狀態（`crm.customer_order.review`）。
 * body：`reopenReason`、`updatedAt`；需新的 `Idempotency-Key`。
 */
export async function reopenCustomerOrder(id, payload, { idempotencyKey }) {
  const { data: raw } = await request.post(
    `/crm/customer-order/${id}/reopen`,
    keysToSnake(payload),
    { headers: { 'Idempotency-Key': idempotencyKey } },
  );
  return parseVer4DetailResponse(raw);
}
